import { memo, useEffect } from 'react';
import { Navigate, Outlet, useMatches, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuthStore } from '@/store/useAuthStore';
import PageLoadingSkeleton from '@/shared/components/layout/PageLoadingSkeleton';
import type { RouteHandle } from '@/routes/types';

// 권한 확인 Guard
const PermissionGuard = () => {
	
	const { isLoading, admin } = useAuthStore();
	const matches = useMatches();
	const navigate = useNavigate();
	
	useEffect(() => {
		if (!isLoading && admin!.grade !== 'MASTER') {
			const matchWithPermission = matches.find(m => (m?.handle as RouteHandle)?.permission);
			const permission = (matchWithPermission?.handle as RouteHandle)?.permission;
			
			console.info('permission', permission);
			
			if (permission && !admin!.permissions.includes(permission)) {
				toast.error('해당 페이지에 접근 권한이 없습니다.');
				navigate(-1);
			}
		}
	}, [isLoading, admin, matches, navigate]);
	
	if (isLoading) {
		return <PageLoadingSkeleton />;
	}
	
	return <Outlet />;
	
	// const { isLoading, admin } = useAuthStore();
	// const matches = useMatches();
	//
	// if (isLoading) {
	// 	return <PageLoadingSkeleton />;
	// }
	//
	// // MASTER 등급 프리패스
	// if (admin!.grade === 'MASTER') {
	// 	return <Outlet />;
	// }
	//
	// // 권한 체크
	// const matchWithPermission = matches.find(m => (m?.handle as RouteHandle)?.permission);
	// const permission = (matchWithPermission?.handle as RouteHandle)?.permission;
	//
	// if (permission && !admin!.permissions.includes(permission)) {
	// 	toast.error('해당 페이지에 접근 권한이 없습니다.');
	// 	return <Navigate to="/" replace />;
	// }
	//
	// return <Outlet />;
};

export default memo(PermissionGuard);
